import Vue from 'vue'
import App from './App.vue'
import Filter from "./global/Filter"; // 过滤器
import './global/Global' // 全局变量
import router from './config/Router' // 路由
import store from './store/Index'

import ElementUI from 'element-ui'
import VueMeta from 'vue-meta'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI);
Vue.use(VueMeta);

// 过滤器
for (const key in Filter) {
    if (Filter.hasOwnProperty(key)) {
        const element = Filter[key];
        Vue.filter(key, element)
    }
}

// axios
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "csrf";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
let vue = new Vue();
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    // 特殊处理
    let path = error.response.config.url;
    if ((path === '/api/src/user/asset' || path === '/p/auth/check')) {
        if (error.response.status !== 403) {
            vue.$message.error(`服务暂不可用，请稍后重试！`);
        }
        return Promise.reject(error);
    }
    // 响应错误处理
    let err = error.response.data.result;
    if (err === 'userNotLogin') {
    } else if (err === 'InvalidArgument') {
        if (error.response.data.msg === err) {
            vue.$message.error({ message: '存在非法字符，请检查后重试！' });
        } else {
            vue.$message.error({ message: error.response.data.msg });
        }
    } else if (err === 'CoinNotEnough') {
        vue.$message.error({ message: '安全币余额不足！' });
    } else if (err === 'InternalError') {
        vue.$message.error({ message: '未知错误，请稍后重试！' });
    } else if (err === 'AddressNotExist') {
        vue.$message.error({ message: '收货地址不存在！' });
    } else if (err === 'CaptchaError') {
        vue.$message.error({ message: '验证码错误！' });
        return Promise.resolve();
    } else if (err === 'emptyfile') {
        vue.$message.error({ message: '上传文件为空，请检查后重试！' });
    } else if (err === 'AgreementNotAgreed') {
        vue.$message.error({ message: '请刷新页面阅读并同意《金山办公安全应急响应中心服务协议》才能使用本网站功能。' });
    } else {
        vue.$message.error({ message: error.response.data.msg || `${error.response.config.url} 接口服务暂不可用` });
    }
    return Promise.reject(error);
});
Vue.config.productionTip = false;

// 注册
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
